import React from "react";
import type {
  Message,
  Chat,
} from "../../../../redux/reducers/ChatReducer/ChatSliceTypes";
import type { User } from "../../../../redux/reducers/UserSlice/UserSliceType";
import MessageItem from "../MessageItem";
import EmptyState from "./EmptyState";
import { getName } from "../../utils/messageUtils";

interface MessageListProps {
  messages: Message[];
  messageLoading: boolean;
  page: number;
  currentUser: User | null;
  selectedChat: Chat;
  messageContainerRef: React.RefObject<HTMLDivElement>;
  onScroll: () => void;
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  messageLoading,
  page,
  currentUser,
  selectedChat,
  messageContainerRef,
  onScroll,
  setMessages,
}) => {
  React.useEffect(() => {
    console.log("=== MESSAGE LIST DEBUG ===");
    console.log("Total message groups:", messages?.length);

    messages?.forEach((msgGroup: Message, idx: number) => {
      console.log(`Group ${idx} (${msgGroup.date}):`, {
        messageCount: msgGroup.messages?.length,
        messageIds: msgGroup.messages?.map((m: any) => m.id),
        messages: msgGroup.messages,
      });
    });
  }, [messages]);

  return (
    <div
      ref={messageContainerRef}
      onScroll={onScroll}
      className="flex-1 overflow-y-auto px-4 sm:px-6 py-4 sm:py-6 space-y-4"
      style={{ maxHeight: "calc(100vh - 200px)" }}
    >
      {messageLoading && page === 1 ? (
        <div className="flex justify-center items-center h-full">
          <div className="w-12 h-12 border-4 border-neutral-300 border-t-[#F56948] rounded-full animate-spin"></div>
        </div>
      ) : messages.length === 0 ? (
        <EmptyState type="no-messages" />
      ) : (
        <>
          {messageLoading && page > 1 && (
            <div className="flex justify-center py-2">
              <div className="w-6 h-6 border-2 border-neutral-300 border-t-[#F56948] rounded-full animate-spin"></div>
            </div>
          )}
          {messages?.map((msg: any) => (
            <MessageItem
              key={msg.id}
              message={msg}
              currentUser={currentUser}
              selectChat={selectedChat}
              getName={getName}
              setMessages={setMessages}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default MessageList;
